import { useQuery } from '@tanstack/react-query';

import { model } from '../';

export const useSuggestedInvoiceItemsQueryKey = ['invoice-items', 'suggested'];

export const useSuggestedInvoiceItems = () =>
  useQuery<string[]>(useSuggestedInvoiceItemsQueryKey, model.suggestedItems);
